import * as React from 'react';

import { useRutubePlayer, useRutubeVideoLink } from './hooks';
import { TMediaVideo } from '../../types';

export const RutubePlayer: React.FC<TMediaVideo> = props => {
  const src = useRutubeVideoLink(props.src);

  const iframeRef = React.useRef<HTMLIFrameElement>(null);

  useRutubePlayer(iframeRef);

  return (
    <iframe
      width="100%"
      height="100%"
      src={src}
      frameBorder="0"
      allow="clipboard-write; autoplay"
      allowFullScreen
      ref={iframeRef}
    />
  );
};
